// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "money-25P4S";
export { _1 as "__esModule", _2 as "money" }
export default { "__esModule": _1, "money": _2 }
